import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssDynamicGridPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////

    ////****************** Example 2 ********************************************////

    protected ex2Height1: number = 2;
    protected ex2Width1: number = 4;
    protected ex2Content1: string | null = "Container 1 (2 x 4)";
    protected ex2Height2: number = 1;
    protected ex2Width2: number = 6;
    protected ex2Content2: string | null = "Container 2 (1 x 6)";
    protected ex2Height3: number = 2;
    protected ex2Width3: number = 2;
    protected ex2Content3: string | null = "Container 3 (2 x 2)";

}
